export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/getup_desktop-c08c8eb55bd7cb24229faf0f582da29a.png";